import { IStatistics } from 'pages/Home/types';
import { cdmApi } from '.';

const PREFIX = '/data';

const sharedApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getStatistics: builder.query<
            {
                code: number;
                statistics: IStatistics;
            },
            string[]
        >({ query: (data) => ({ url: `${PREFIX}/statistics`, method: 'POST', data }) }),
    }),
    overrideExisting: false,
});

export const { useGetStatisticsQuery } = sharedApi;
